import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { User } from 'src/app/auth/user.model';
import { AuthService } from 'src/app/auth/auth.service';
import { DataService } from 'src/app/shared/data.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import {DOC_ORIENTATION, NgxImageCompressService} from 'ngx-image-compress';

@Component({
    selector: 'app-change-image',
    templateUrl: './change-image.component.html',
    styleUrls: ['./change-image.component.scss'],
    standalone: false
})
export class ChangeImageComponent implements OnInit {
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropperReady = false;
  imageBase64!: string;
  existingImage: string;
  newImageAdded: boolean;
  @ViewChild('selectFileInput', { static: true }) nativeInputFile!: ElementRef;
  @ViewChild('imageCropper', { static: true }) imageCropper!: ElementRef;
  userID: number;
  croppedImage64!: string;
  title: any;
  imgResultBeforeCompress!:string;
  imgResultAfterCompress!:string;
  sizeOfOriginalImage!:number;
  sizeOFCompressedImage!:number;
  resizeImage = false;
  aspectRatio: any;

  constructor(private authService: AuthService,
              private dataService: DataService,
              public utils: UtilsService,
              public dialog: MatDialog,
              private imageCompress: NgxImageCompressService,
              
              @Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<ChangeImageComponent>) {
                this.userID = this.authService.getUserData().id;
                this.existingImage = data.existingImage;
                this.aspectRatio = data.aspectRatio;
                this.newImageAdded = false;
                this.title = data.title;
                if (data.resizeImage === true) {
                  this.resizeImage = data.resizeImage;
                }
              }

  ngOnInit(): void {
    this.imageBase64 = 'data:image/png;base64,' + this.existingImage;
  }

  fileChangeEvent(event: Event): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    var orientation = -1;
    if (event.base64) {
      this.processBase64(event.base64, orientation);
    } else if (event.blob) {
      const reader = new FileReader();
      reader.readAsDataURL(event.blob);
      reader.onload = () => {
        const base64 = reader.result as string;
        this.processBase64(base64, orientation);
      };
    } 
  }


  private processBase64(base64: string, orientation: number) {
    this.sizeOfOriginalImage = this.imageCompress.byteCount(base64);
    this.imageCompress.compressFile(base64, orientation, 100, 100).then(
      result => {
        this.imgResultAfterCompress = result;
        this.sizeOFCompressedImage = this.imageCompress.byteCount(result);
        this.croppedImage = result;
        this.croppedImage64 = result;
      }
    );
  }

  imageLoaded() {
    this.cropperReady = true;
  }

  imageLoadFailed() {
  }

  savePhotoChanges() {
    const payload = {
      ImageData: this.croppedImage,
      croppedImage64: this.croppedImage64,
      UserId: parseInt(this.userID.toString(), 10)
    };
    if (this.cropperReady) {
      this.dialogRef.close(payload);
    } else {
      this.closeDialog();
    }
  }

  uploadNewPhoto() {
    this.cropperReady = false;
    this.newImageAdded = true;
    this.nativeInputFile.nativeElement.click();
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
